/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
import React from 'react';
import {AppRoot, PageContainer} from './src/PageContainer';

const NO_LAYOUT_PATHS = ['/designs'];

export const wrapPageElement = ({element, props}) => {
  if (NO_LAYOUT_PATHS.includes(props.path)) {
    return element;
  }
  return <PageContainer {...props}>{element}</PageContainer>;
};

export const wrapRootElement = ({element}) => {
  return <AppRoot>{element}</AppRoot>;
};

export const onRouteUpdate = ({location}) => {
  const widget = document.querySelector('div[script-id="UOmW9"]');
  if (widget) {
    if (location.pathname.includes('/designs')) {
      widget.style.display = 'none';
    } else {
      widget.style.display = 'block';
    }
  }
};
